import { Component, input, inject, effect } from "@angular/core";
import { JobsAndBillingNoteService } from "@shared/jobs-and-billing-notes-service";
import { NotesPanelComponent } from "@app/card-modal-component/panels/card-panels/notes-panel";
import { BaseNotesService } from "@classes/notes.class";
import { iFirmNotesPanelComponent } from "../../ifirm-notes-panel";

@Component({
    selector: "wk-jobs-billings-notes-panel",
    imports: [NotesPanelComponent, iFirmNotesPanelComponent],
    templateUrl: "./jobs-billing-card-notes-panel.component.html",
    styleUrl: "./jobs-billing-card-notes-panel.component.scss",
    providers: [JobsAndBillingNoteService, { provide: BaseNotesService, useExisting: JobsAndBillingNoteService }],
})
export class JobsBillingCardNotesPanelComponent {
    private readonly jobsAndBillingNoteService = inject(JobsAndBillingNoteService);

    public id = input.required<string | undefined>();

    constructor() {
        effect(() => {
            const id = this.id();
            if (!id) return;
            this.jobsAndBillingNoteService.id.set(id);
        });
    }
}
